// Assets
import { Routes, Route, useLocation } from "react-router-dom";
import React, { lazy, useEffect, useState } from "react";
import { getSeoDataApi } from "../../../api/seo/seo";
import HomeScreen from "../../../AppHomeScreen";
// Component
// import Home from "../../../pages/restuarant-page/home/home";
import Gpay from "../../../components/PaymentForm";
import Adminpanel from "../pages/Adminpanel";
import CheckoutPage from "../../../pages/checkout/checkoutV2";
// import CheckoutPageV1 from "../../../pages/checkout/checkout";
import Checkoutpageskele from "../../../pages/checkout/Checkoutpageskeleton";
import Loadable from "../../../router/loadable";
import Tablebookingmenu from "../../../pages/menu/tablebookingmenu";
import Tablebookingpayment from "../../../pages/tablebookingpayment/tablebookingpayment";
import CommonWalletTC from "../../wallet-tc/wallet-tc";
import LeadForm from "../../../pages/franchise/leadform/LeadMainFile";

const HomeSlidev1 = Loadable(lazy(() => import("../../../pages/home/sliderv1")));
//top bar Lazy
const Becomepartner = Loadable(
  lazy(() => import("../../../pages/become-partner/becomepartner"))
);
const Help = Loadable(lazy(() => import("../../../pages/help/help")));
//footer lazy
const Faq = Loadable(lazy(() => import("../../../pages/faq/faq")));
const Blog = Loadable(lazy(() => import("../../../pages/blog/blog")));
const TermsCondition = Loadable(
  lazy(() => import("../../../pages/terms-condition/terms-condition"))
);
const Partners = Loadable(
  lazy(() => import("../../../pages/partners-terms/partners-terms"))
);
const AllArea = Loadable(lazy(() => import("../../../pages/all-area/allarea")));
const AllCuisines = Loadable(
  lazy(() => import("../../../pages/all-cuisines/all-cuisines"))
);
const Brand = Loadable(
  lazy(() => import("../../../pages/our-brand/our-brand"))
);
const Reseller = Loadable(
  lazy(() => import("../../../pages/reseller/reseller"))
);
const Contactless = Loadable(
  lazy(() => import("../../../pages/contactless-dining/contactless"))
);
const Aboutus = Loadable(lazy(() => import("../../../pages/aboutus/aboutus")));
const Career = Loadable(lazy(() => import("../../../pages/career/career")));
const Allergy = Loadable(lazy(() => import("../../../pages/allergy/allergy")));
const Policyprivacy = Loadable(
  lazy(() => import("../../../pages/policy-privacy/policy"))
);

// Myaccount Lazy
const Myaccount = Loadable(
  lazy(() => import("../../../pages/myaccount/myaccount-layout"))
);
const Profile = Loadable(
  lazy(() => import("../../../pages/myaccount/components/profile/profile"))
);
const OrderStatus = Loadable(
  lazy(() =>
    import("../../../pages/myaccount/components/orderstatus/orderstatus")
  )
);

const Orderstatusskle = Loadable(
  lazy(() =>
    import("../../../pages/myaccount/components/orderstatus/Orderstatusskle")
  )
);
const WalletTC = Loadable(
  lazy(() => import("../../../pages/myaccount/components/wallet-tc/wallet-tc"))
);
const WalletPage = Loadable(
  lazy(() => import("../../../pages/myaccount/components/wallet/wallet"))
);
const SavedCards = Loadable(
  lazy(() => import("../../../pages/myaccount/components/wallet/savedcard"))
);
const AddCard = Loadable(
  lazy(() => import("../../../pages/myaccount/components/wallet/addcard"))
);
const WalletHistory = Loadable(
  lazy(() => import("../../../pages/myaccount/components/wallet/history"))
);
const AddressBook = Loadable(
  lazy(() =>
    import("../../../pages/myaccount/components/addressbook/addressbook")
  )
);
const MyOrder = Loadable(
  lazy(() => import("../../../pages/myaccount/components/myorder/myorder"))
);
const OrderDetailPage = Loadable(
  lazy(() => import("../../../pages/myaccount/components/myorder/orderdetail"))
);
const StuartTrack = Loadable(
  lazy(() =>
    import(
      "../../../pages/myaccount/components/orderstatus/components/stuart-track"
    )
  )
);
const Cookies = Loadable(lazy(() => import("../../../pages/cookies/cookies")));
//new MyAccount
const Tablebooking = Loadable(
  lazy(() =>
    import(
      "../../../pages/myaccount/components/Tablebooking/tablebooking"
    )
  )
);
const FeedbackForm1 = Loadable(
  lazy(() =>
    import(
      "../../../pages/myaccount/components/Feedbackacc/feedbackv2"
    )
  )
);
//menuPage Lazy
const MenuPage = Loadable(lazy(() => import("../../../pages/menu/menu-page")));
const AllMenu = Loadable(lazy(() => import("../../../pages/menu/menu")));
const MenuAbout = Loadable(lazy(() => import("../../../pages/menu/about")));
const MenuReview = Loadable(lazy(() => import("../../../pages/menu/review")));
const MenuPageShopping = Loadable(
  lazy(() => import("../../../pages/menu/menuShopingPage"))
);
const MenuProductDetail = Loadable(
  lazy(() => import("../../../pages/menu/menuDetail"))
);

// import AllMenu from "../pages/menu/menu";
// import MenuAbout from "../pages/menu/about";
// import MenuReview from "../pages/menu/review";

//lazy load-R
const Home = Loadable(lazy(() => import("../../../pages/restuarant-page/home/home")));
const Book = Loadable(lazy(() => import("../../../pages/restuarant-page/home/home")));
const Ordernow = Loadable(lazy(() => import("../../../pages/restuarant-page/home/home")));
const Accountdeletion = Loadable(lazy(() => import("../../../pages/restuarant-page/home/home")));
const ListPage = Loadable(lazy(() => import("../../../pages/listpage/listpage")));
const Stuart = Loadable(lazy(() => import("../../../pages/stuartT&C/stuart")));
const Cardrefund = Loadable(lazy(() => import("../../../pages/card-refund/card-refund")));
const Errorpage = Loadable(lazy(() => import("../../../pages/errorpage/errorpage")));
const WithOrder = Loadable(lazy(() => import("../../../pages/help/with-order")));
const OfferInfo = Loadable(lazy(() => import("../../../pages/help/offer-information")));
const GuideFusion = Loadable(lazy(() => import("../../../pages/help/guid-fusion")));
const AccountOptions = Loadable(lazy(() => import("../../../pages/help/account-options")));
const Leadsignup = Loadable(lazy(() => import("../../../pages/leadsignup/leadsignup")));
// const CheckoutPage = Loadable(lazy(() => import("../../../pages/checkout/checkoutV2")));
const CheckoutPageV1 = Loadable(lazy(() => import("../../../pages/checkout/checkout")));
// const Checkoutpageskele = Loadable(lazy(() => import("../../../pages/checkout/Checkoutpageskeleton")));
const BlogDetail = Loadable(lazy(() => import("../../../pages/blogdetails/blogdetails")));
const Rateus = Loadable(lazy(() => import("../../../pages/rate-us/rate-us")));
const Refund = Loadable(lazy(() => import("../../../pages/refund-expired/refund")));
const Login = Loadable(lazy(() => import("../../../pages/restuarant-page/home/home")));
const UploadMenu = Loadable(lazy(() => import("../../../pages/restuarant-page/home/UploadMenu")));
const NotFound = Loadable(lazy(() => import("../../../pages/restuarant-page/error/error")));
const PrivacyPolicy = Loadable(lazy(() => import("../../../pages/restuarant-page/other/privacypolicy")));
const TermsAndCondition = Loadable(lazy(() => import("../../../pages/restuarant-page/other/terms")));
const AllergyInfo = Loadable(lazy(() => import("../../../pages/restuarant-page/other/allergy")));
const ReviewAll = Loadable(lazy(() => import("../../../pages/restuarant-page/review/reviewall")));
const FeedBackForm = Loadable(lazy(() => import("../../../pages/restuarant-page/review/feedback")));

const Routing = () => {
  const [analyticCode, setAnalyticCode] = useState(); // Initialize sitemap state to null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = {
          domain: window.location.hostname,
        };
        const apiResponse = await getSeoDataApi(formData);
        if (apiResponse?.data?.status === false) {
          // Handle error condition
          console.error(
            "Error fetching sitemap data:",
            apiResponse.data.message
          );
        } else {
          // Handle success condition
          setAnalyticCode(apiResponse.data.message.analytic_code); // Update sitemap state with the fetched data
        }
      } catch (error) {
        console.error("Error fetching sitemap data:", error);
      }
    };

    fetchData(); // Call fetchData when the component mounts
  }, []); // Empty dependency array to ensure this effect runs only once

  const location = useLocation();
  const loginCheck1 = localStorage.getItem("isLoggedIn");
  const loginCheck = loginCheck1 === "true";
  // useEffect(() => {
  //   if (analyticCode) {
  //     const TRACKING_ID = analyticCode;
  //     ReactGA.initialize(TRACKING_ID);
  //     ReactGA.pageview(window.location.pathname + window.location.search);
  //   }
  // }, [analyticCode, location]);
  function gtag() {
    window.dataLayer.push(arguments);
  }
  useEffect(() => {
    if (analyticCode) {
      // Add the Google Analytics script to the document head
      const script = document.createElement("script");
      script.async = true;
      script.src =
        `https://www.googletagmanager.com/gtag/js?id=` + analyticCode;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];

      gtag("js", new Date());
      gtag("config", analyticCode);

      // Track page views
      gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });

      // Cleanup function to remove the script
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [analyticCode, location]);

  const RoutingDatas = [
    {
      url: "/",
      element: <Home />,
    },
    {
      url: "/app",
      element: loginCheck ? <Home /> : <HomeScreen />,
    },
    {
      url: "*",
      element: <NotFound />,
    },
    {
      url: "/privacy",
      element: <PrivacyPolicy />,
    },
    {
      url: "/terms",
      element: <TermsAndCondition />,
    },
    {
      url: "/allergy",
      element: <AllergyInfo />,
    },
    {
      url: "/review",
      element: <ReviewAll />,
    },
    {
      url: "/rate",
      element: <FeedBackForm />,
    },
  ];
  const RoutingPaths = [
    { url: "/", element: <Home /> },
    { url: "*", element: <Errorpage /> },
    { url: "/sliderv1", element: <HomeSlidev1 /> },
    { url: "/login", element: <Login /> },
    // { url: "/teststripe", element: <Teststripe /> },
    // { url: "/testusec", element: <MyuseApp /> },
    { url: "/Admin", element: <Adminpanel /> },
    { url: "/book", element: <Book /> },
    { url: "/ordernow", element: <Ordernow /> },
    { url: "/accountdeletion", element: <Accountdeletion /> },
    { url: "/gpay", element: <Gpay /> },
    { url: "/list", element: <ListPage /> },
    { url: "/general-terms", element: <TermsCondition /> },
    { url: "/partner-terms", element: <Partners /> },
    { url: "/our-brand", element: <Brand /> },
    { url: "/stuart-delivery", element: <Stuart /> },
    { url: "/faq", element: <Faq /> },
    { url: "/allergy", element: <Allergy /> },
    { url: "/cookies", element: <Cookies /> },
    { url: "/refundlinkexpired", element: <Refund /> },
    { url: "/contactlessdinning", element: <Contactless /> },
    { url: "/cardrefund", element: <Cardrefund /> },
    { url: "/privacy", element: <Policyprivacy /> },
    { url: "/about", element: <Aboutus /> },
    { url: "/career", element: <Career /> },
    { url: "/partner", element: <Becomepartner /> },
    { url: "/help", element: <Help /> },
    { url: "/help-with-order", element: <WithOrder /> },
    { url: "/offer-information", element: <OfferInfo /> },
    { url: "/guide-fusion", element: <GuideFusion /> },
    { url: "/account-options", element: <AccountOptions /> },
    { url: "/signup", element: <Leadsignup /> },
    { url: "/area", element: <AllArea /> },
    { url: "/cuisines", element: <AllCuisines /> },
    { url: "/reseller", element: <Reseller /> },
    { url: "/blog", element: <Blog /> },
    { url: "/menus", element: <UploadMenu /> },
    { url: "/become-franchise", element: <LeadForm /> },

  ];
  const MyAccountRouts = [
    {
      moblink: true,
      url: "/myaccount",
      element: <Myaccount />,
      subpaths: [
        {
          url: "profile",
          element: <Profile />,
        },
        {
          url: "orderstatus",
          element: <OrderStatus />,
        },
        {
          url: "Orderstatusskle",
          element: <Orderstatusskle />,
        },
        {
          url: "wallet-tc",
          element: <WalletTC />,
        },
        {
          url: "wallet",
          element: <WalletPage />,
        },
        {
          url: "savedcards",
          element: <SavedCards />,
        },
        {
          url: "addcard",
          element: <AddCard />,
        },
        {
          url: "wallethistory",
          element: <WalletHistory />,
        },
        {
          url: "addressbook",
          element: <AddressBook />,
        },
        {
          url: "myorder",
          element: <MyOrder />,
        },
        {
          url: "orderdetail",
          element: <OrderDetailPage />,
        },
        {
          url: "stuarttrack",
          element: <StuartTrack />,
        },
        {
          url: "tablebooking",
          element: <Tablebooking />,
        }, {
          url: "yourorder",
          element: <MyOrder />,
        },
        {
          url: "help",
          element: <Help />,
        },
        {
          url: "feedbackmyaccount",
          element: <FeedbackForm1 />,
        },
        {
          url: "termsandcondition",
          element: <CommonWalletTC />,
        },
      ],
    },
  ];

  return (
    <>
      <>
        <Routes>
          {RoutingDatas.map((RoutingData, index) => (
            <Route
              key={index}
              exact
              path={RoutingData.url}
              element={RoutingData.element}
            />
          ))}
          {RoutingPaths.map((RoutingPath, index) => (
            <Route
              key={index}
              exact
              path={RoutingPath.url}
              orderId={RoutingPath.orderId}
              element={RoutingPath.element}
            />
          ))}

          <Route path="/:path" element={<MenuPage />}>
            <Route index element={<AllMenu />} />
            <Route path="menu" element={<AllMenu />} />
            <Route path="review" element={<MenuReview />} />
            <Route path="about" element={<MenuAbout />} />
            <Route path="tablebook" element={<Tablebookingmenu />} />
          </Route>
          <Route path="/:path/product/:id" element={<MenuProductDetail />} />
          <Route path="/:path/shopping" element={<MenuPageShopping />} />
          <Route path="/:path/rateus/:orderId" element={<Rateus />} />
          <Route path="tablebookingpayment" element={<Tablebookingpayment />} />
          <Route path="/:path/checkout" element={<CheckoutPage />} />
          <Route path="/:path/oldcheckout" element={<CheckoutPageV1 />} />
          <Route path="/:path/Checkoutpageskeleton" element={<Checkoutpageskele />} />
          <Route path="/blog/:path" element={<BlogDetail />} />
          {MyAccountRouts.map((MyAccountRout, index) => (
            <Route
              key={index}
              path={MyAccountRout.url}
              element={MyAccountRout.element}
            >
              <Route index element={<Profile />} />
              {MyAccountRout.subpaths.map((subpath, subIndex) => (
                <Route
                  key={subIndex}
                  path={subpath.url}
                  element={subpath.element}
                />
              ))}
            </Route>
          ))}
          {MyAccountRouts[0].subpaths.map((subpath, index) => (
            <Route
              key={index}
              path={"/" + subpath.url}
              element={subpath.element}
            />
          ))}
        </Routes>
      </>
    </>
  );
};
export default Routing;
